<template>
    <section>
        <div class="box" v-if="products.length > 0" :key="'products found'">
            <Flicking
                class="carousel"
                :options="{
                    align: 'prev',
                    circular: true,
                    duration: 200,
                    easing: function(x) {
                        return x;
                    }
                }"
                ref="flicking"
            >
                <div
                    class="panel"
                    v-for="product in products"
                    :key="product.id"
                >
                    <div class="product__box">
                        <product-second-card :product="product">
                        </product-second-card>
                    </div>
                </div>
            </Flicking>

            <div class="nav__box">
                <div class="prev">
                    <button @click="prevSlide">
                        <svg
                            width="8"
                            height="13"
                            viewBox="0 0 8 13"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M6.73828 11.522L1.86872 6.65241L6.73828 1.78284"
                                stroke="white"
                                stroke-width="1.8"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </button>
                </div>

                <div class="next">
                    <button @click="nextSlide">
                        <svg
                            width="8"
                            height="13"
                            viewBox="0 0 8 13"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M1.26172 11.522L6.13128 6.65241L1.26172 1.78284"
                                stroke="white"
                                stroke-width="1.8"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </button>
                </div>
            </div>
        </div>

        <div class="box" v-else>
            <h2 v-if="products.length === 0" :key="'products no found'">
                Ничего не найдено!
            </h2>
        </div>
    </section>
</template>

<script>
import ProductSecondCard from "./ProductSecondCard";
import { Flicking } from "@egjs/vue-flicking";

export default {
    components: {
        ProductSecondCard,
        Flicking
    },

    props: {
        products: {
            type: Array,
            required: true
        }
    },

    methods: {
        async prevSlide() {
            await this.$refs.flicking.prev().catch(() => void 0);
            await this.$refs.flicking.prev().catch(() => void 0);
            await this.$refs.flicking.prev().catch(() => void 0);
        },

        async nextSlide() {
            await this.$refs.flicking.next().catch(() => void 0);
            await this.$refs.flicking.next().catch(() => void 0);
            await this.$refs.flicking.next().catch(() => void 0);
        },

        changePanelsPerViewCount() {
            const innerWidth = window.innerWidth;
            if (innerWidth >= 1200) this.$refs.flicking.panelsPerView = 6;
            if (innerWidth < 1200) this.$refs.flicking.panelsPerView = 4;
            if (innerWidth < 992) this.$refs.flicking.panelsPerView = 3;
            if (innerWidth < 768) this.$refs.flicking.panelsPerView = 2.1;
        }
    },

    async mounted() {
        try {
            this.changePanelsPerViewCount();
        } catch {}
    }
};
</script>

<style lang="scss" scoped>
@import url("../../../../../node_modules/@egjs/vue-flicking/dist/flicking.css");
// Or, if you have to support IE9
@import url("../../../../../node_modules/@egjs/vue-flicking/dist/flicking-inline.css");

.box {
    display: flex;
    position: relative;

    .slick-dots {
        position: relative;
    }

    .exp {
        img {
            height: 200px;
            width: 200px;
        }
    }

    .carousel {
        max-width: 1440px;
        overflow-x: hidden;

        .product__box {
            padding: 10px 7px;
        }
    }

    .nav__box {
        z-index: 20;
        .prev,
        .next {
            position: absolute;
            top: 38%;
        }

        .prev {
            left: 0;
            margin-left: 15px;
        }

        .next {
            right: 0;
            margin-right: 15px;
        }

        button {
            width: 40px;
            height: 40px;

            border: none;
            outline: none;
            font-size: 16px;
            border-radius: 4px;

            color: #ffffff;
            background-color: #3E5C45;

            &:hover {
                cursor: pointer;
                background-color: #6C9672;
            }
        }

        button.disabled {
            background-color: #e0e0e0;
            color: #808080;
        }
    }

    h2 {
        padding-right: 7px;
        padding-left: 7px;
        margin-bottom: 15px;
        font-family: Acrom, sans-serif;
        width: 100%;
        font-weight: 700;
        font-size: 22px;
        line-height: 1.4;
        color: #363f4d;
    }
}

@media only screen and (max-width: 550px) {
    .box {
        .nav__box {
            display: none;
        }
    }
}
</style>
